import BaseApiService from "./BaseApiService"
import axios          from "axios"

export interface ConfigItem {
  key: string
  value: any
  type: "int" | "varchar" | null
}

export interface ConfigValue<T = any> {
  value: T | null
  type: "int" | "varchar" | "bool" | "double" | null
  items: ConfigItem[]
}

export default class UserConfigService extends BaseApiService {
  getValue<T = any>(type: string, key: string) {
    const url = this.getApiUrl(`/config/get-value?type=${type}&key=${key}`, "config")
    return this.processRequest<ConfigValue<T>>(axios.get(url))
  }

  setValue(type: string, key: string, value: any, valueType: "varchar" | "int" | "bool" | "double" = "varchar", itemKey?: string) {
    const url = this.getApiUrl("/config/set-value", "config")
    const body: Record<string, any> = { type, key, value, valueType }
    if (itemKey) {
      body.itemKey = itemKey
    }
    return this.processRequest<{ success: boolean, message: string | null }>(axios.post(url, body))
  }
}
